import { create } from 'zustand';

import { CustomerVendorOption, DropdownOption } from 'types/DropdownOption';

interface AccountingDataState {
  customerVendors: CustomerVendorOption[];
  setCustomerVendors: (customerVendors: CustomerVendorOption[]) => void;
  departments: DropdownOption[];
  setDepartments: (departments: DropdownOption[]) => void;
  glAccounts: DropdownOption[];
  setGLAccounts: (glAccounts: DropdownOption[]) => void;
}

export const useAccountingDataStore = create<AccountingDataState>()((set) => ({
  customerVendors: [],
  setCustomerVendors: (customerVendors) => set({ customerVendors }),
  departments: [],
  setDepartments: (departments) => set({ departments }),
  glAccounts: [],
  setGLAccounts: (glAccounts) => set({ glAccounts }),
}));
